module.exports = __webpack_public_path__ + "media/images/emoticons/sign01-da41d254bba5e502347cc5f84ca4f69d.gif";